import React, { FormEvent, useEffect, useMemo, useState } from 'react'
import queryString from 'query-string'
import moment from 'moment'
import { useHistory, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { RadioChangeEvent } from 'antd'
import { LoadingSpinner, RadioAntd } from 'Containers/ui'
import { useMediaQuery } from 'react-responsive'

import {
  BudgetRange,
  CampaignPlatformTypeEnum,
  CampaignToSchedule,
} from 'Types/index'
import { PaymentMethodEnum, Roles } from 'Constants/enums'
import {
  getCampaignStatus,
  sendStripePaymentGTMThunk,
} from 'Redux/actions/campaignActions'
import {
  checkCoupon,
  // getVaultedShopper,
  removeCoupon,
  submitStripePayment,
} from 'Redux/actions/scheduleActions'
import {
  getArtistBalance,
  getCountryName,
  getUserSelector,
} from 'Redux/selectors/auth'
import { IconLockMobile, IconProtection } from 'Stories/Icon/Icon.stories'
import { getAllGenres } from 'Redux/actions/genresActions'
import { getLanguagesForExistingPlaylists } from 'Redux/actions/languagesActions'
import { changeSidebarVisibility } from 'Redux/actions/sidebarActions'
import { sendPaymentStartEvent } from 'Redux/actions/googleAnalyticsActions'

import { getCollapse } from 'Redux/selectors/sidebar'
import {
  getAmountOfCampaigns,
  getCampaignToSchedule,
  getCampaigns,
} from 'Redux/selectors/campaigns'
import {
  formStates,
  getBudgetRange,
  getCoupon,
  getIsUpdateCampaignLoading,
} from 'Redux/selectors/scheduledCampaign'
import {
  campaignBudgetReceived,
  campaignScheduleStartEvent,
  checkIsGTMPaymentEventNeeded,
  checkoutConfirmedPayment,
  checkoutViewEvent,
  couponAppliedEvent,
  locationEvent,
  pageInfo,
  pageViewEvent,
  paymentMethodChanged,
  paymentCancelledEvent,
  PurchaseTypeEnum,
} from 'Helpers/tagManager'
import { Steps } from 'Containers/ui/Steps'
import arrowIcon from 'Shared/img/svg/arrow.svg'

import {
  CardImg,
  CardsImgWraper,
  RadioLabelContainer,
  StyledImgWrapper,
  StyledSpan,
} from 'Containers/ScheduleCampaign/components/Payment/styles'
import visaLight from 'Shared/img/svg/visa.svg'
import mastercardLight from 'Shared/img/svg/masterCard.svg'
import discoverLight from 'Shared/img/svg/discover.svg'
import jcbLight from 'Shared/img/svg/jcb.svg'
import dinersLight from 'Shared/img/svg/dinersClub.svg'
import applePay from 'Shared/img/svg/applePay.svg'
import googlePay from 'Shared/img/svg/googlePay.svg'

import { Mobile } from 'Shared/components/Responsive'
import paypalLogo from 'Shared/img/svg/paypal.svg'
import PaypalButton from 'Containers/ScheduleCampaign/components/PaypalButtonOld/PaypalButton'

import { useBudget } from 'Containers/ScheduleCampaign/hooks'
import {
  AddedTrack,
  BlueSnapErrorsAlert,
  CampaignIsScheduledComponent,
  Checkout,
  GenresAndLanguagesSettings,
  PromocodePopup,
  ReachSettings,
} from './components'
import { RouteParams, ScheduleCampaignProps } from './props'
import {
  AlertProtectionWrapper,
  AlertProtectionWrapperText,
  BackButton,
  BluesnapErrorContainer,
  ButtonsContainer,
  Container,
  ContainerPayment,
  ContinueButton,
  ContinueButtonPaypal,
  HiddenContentWrapper,
  MainContentContainer,
  PageTitle,
  PageTitleContainer,
  PaypalButtonWrapper,
  SecurePaymentBlock,
  SecurePaymentText,
  SetupContainer,
  StepTitle,
  TotalContainer,
  TotalLabel,
  TotalSum,
} from './styles'
import './style.scss'
import { useBluesnapPayments } from '../../Hooks/bluesnap'
import { useCheckout } from '../../Hooks/payment'

export const ScheduleCampaignComponent: React.FC<ScheduleCampaignProps> = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const userData = useMemo(() => queryString.parse(location.search), [
    location.search,
  ])

  const params: RouteParams = useParams()
  const campaignNumberFromUrl = +params.number
  const isMobile = useMediaQuery({ maxWidth: 576 })
  const url = window.location.href

  const { couponForm } = useSelector(formStates)
  const campaigns = useSelector(getCampaigns)
  const campaignDetails = useSelector(getCampaignToSchedule)
  const isUpdateCampaignLoading = useSelector(getIsUpdateCampaignLoading)

  const balance = useSelector(getArtistBalance)
  const country: string = useSelector(getCountryName)
  const coupon = useSelector(getCoupon)
  const user = useSelector(getUserSelector)
  // const pfToken: string = useSelector(getPftoken)
  // const shopper: Shopper = useSelector(getShopper)
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)
  const collapse: boolean = useSelector(getCollapse)
  const budgetRange: BudgetRange = useSelector(getBudgetRange)

  const [budget, setBudget] = useState(0)
  const [currentStep, setCurrentStep] = useState(1)
  const [isContinueActive, setIsContinueActive] = useState({
    1: false,
    2: false,
    3: false,
  })
  const [isOpenModalPromocode, setModalPromocode] = useState(false)
  const [isCoupon, setIsCoupon] = useState(false)
  const [couponErrorMessage, setCouponErrorMessage] = useState<string | null>(
    null
  )
  const [discount, setDiscount] = useState(0)
  // const [isAddNewCardOpened, setIsAddNewCardOpened] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  // const [isBluesnapLoading, setIsBluesnapLoading] = useState<boolean>(false)
  const [isScheduleFinished, setIsScheduleFinished] = useState<boolean>(false)

  const [selectedDate, setSelectedDate] = useState(
    moment()
      .add(2, 'days')
      .format()
  )
  const [dateFromString, setDateFromString] = useState<string | null>('')
  const { currencyRate, currencySymbol, convertFromUsd } = useBudget({ budget })

  const {
    // initialiseBluesnap,
    // onChangeCardData,
    bluesnapSecurityCardData,
    bluesnapSecurityCountry,
    bluesnapErrorText,
    closeBluesnapErrorAlert,
    isBluesnapInitialized,
    isBluesnapButtonDisabled,
    calculateTotalPrice,
  } = useBluesnapPayments({})

  const {
    cardOption,
    paymentOption,
    closePaymentErrorAlert,
    // setCardOption,
    setPaymentOption,
    onSuccessPaypal,
    submitPayment,
    paymentError,
    isPaymentButtonLoading,
    onClickPaypalEventSend,
  } = useCheckout({
    // @ts-ignore
    setIsLoading,
    // @ts-ignore
    setIsScheduleFinished,
    selectedDate,
    setSelectedDate,
  })

  // GTM Event
  const onCheckoutConfirmedPaymentEventSend = (
    campaign: CampaignToSchedule,
    userId: number | string,
    paymentMethod: PaymentMethodEnum
  ): void => {
    checkoutConfirmedPayment({
      campaignType: campaign.type,
      campaignNumber: campaignDetails.type === 'first' ? 1 : amountOfCampaigns,
      campaignId: Number(campaign.id),
      userId,
      resultPrice: campaign?.price,
      genreList: campaign?.genres.map(genre => genre.name).join(),
      languageList: campaign?.languages.map(language => language.name).join(),
      paymentMethod,
      campaignPlatform: CampaignPlatformTypeEnum.SPOTIFY,
      is_feed: campaign?.is_feed || false,
    })
  }

  // On PayPal click GTM events
  const onPaypalClickSendEvents = (): void => {
    onClickPaypalEventSend(campaignDetails.id, window.location.href)
    onCheckoutConfirmedPaymentEventSend(
      campaignDetails,
      user.id,
      PaymentMethodEnum.PayPal
    )
  }

  const goToCampaignsList = () => {
    history.push('/campaigns')
  }

  const checkCampaign = (campaignID: number) => {
    dispatch(
      getCampaignStatus(campaignID, (err, res) => {
        if (err) goToCampaignsList()
        if (res.payment) {
          if (
            // @ts-ignore
            res.campaign.status === 'running' ||
            // @ts-ignore
            res.campaign.status === 'ended'
          ) {
            history.push(`/campaigns/view/${campaignID}`)
          } else {
            goToCampaignsList()
          }
        }
      })
    )
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const paymentStatus = queryParams.get('paymentStatus')
    if (paymentStatus !== 'success') {
      checkCampaign(+params.number)
    }
    !isMobile && !collapse && dispatch(changeSidebarVisibility())
    dispatch(getAllGenres())
    dispatch(getLanguagesForExistingPlaylists())
    // dispatch(getVaultedShopper())
  }, [])

  // useEffect(() => {
  //   !pfToken && dispatch(getBluesnapPftoken())
  //   pfToken && isAddNewCardOpened && initialiseBluesnap(pfToken)
  // }, [pfToken, isAddNewCardOpened])

  // const cardFormRef = useCallback(
  //   node => {
  //     if (node !== null) {
  //       if (!isBluesnapInitialized) {
  //         initialiseBluesnap(pfToken)
  //         // setIsBluesnapLoading(true)
  //       }
  //     }
  //   },
  //   [pfToken]
  // )

  const [isCampaignBudgetReceived, setCampaignBudgetReceived] = useState(false)

  useEffect(() => {
    // if (isBluesnapInitialized) setIsBluesnapLoading(false)

    // GTM campaign_budget_received
    if (currentStep === 2 && budgetRange) {
      const initBudget = (budgetRange.max + budgetRange.min) / 2

      !isCampaignBudgetReceived &&
        campaignBudgetReceived(
          campaignDetails.type,
          CampaignPlatformTypeEnum.SPOTIFY,
          amountOfCampaigns,
          Number(campaignDetails.id),
          user.id,
          initBudget,
          campaignDetails?.genres.map(genre => genre.name).join(),
          campaignDetails?.languages.map(language => language.name).join(),
          campaignDetails?.is_feed || false
        )
      setCampaignBudgetReceived(true)
    }
  }, [isBluesnapInitialized, currentStep, budgetRange, campaignDetails?.id])

  useEffect(() => {
    coupon && setDiscount(coupon.discount)
    coupon && setIsCoupon(true)
  }, [coupon])

  const [componentDidMount, setComponentDidMount] = useState(false)

  useEffect(() => {
    if (!componentDidMount) {
      setComponentDidMount(true)
    }

    user && pageViewEvent(user, pageInfo.scheduleCampaign)
    locationEvent()
  }, [user])

  const submitCoupon = (couponValue: string): void => {
    if (couponValue.includes('%') || couponValue.includes('?')) {
      setCouponErrorMessage(t('scheduleCampaignPage.couponDoesntExist'))
    } else {
      dispatch(
        checkCoupon(couponValue, (error, res) => {
          if (error) {
            setCouponErrorMessage(error.error ?? '')
          } else {
            const memoDiscount =
              campaignDetails?.price * (res.coupon.discount / 100)
            couponAppliedEvent(
              user,
              campaignDetails.type,
              res.coupon,
              memoDiscount.toFixed(2)
            )
            setCouponErrorMessage(null)
            setModalPromocode(false)
          }
        })
      )
    }
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const paymentStatus = queryParams.get('paymentStatus')
    const dateInfo = queryParams.get('startDate')
    if (paymentStatus === 'success') {
      setIsScheduleFinished(true)
      setDateFromString(dateInfo)
      const isGtmNeeded = checkIsGTMPaymentEventNeeded(
        campaignNumberFromUrl,
        'success'
      )

      // payment complete GTM
      isGtmNeeded &&
        dispatch(
          sendStripePaymentGTMThunk({
            campaignId: campaignNumberFromUrl,
            resultType: 'success',
            userId: user.id,
            userRole: user.role as Roles,
            campaignDetails,
            user,
          })
        )
    }
    if (paymentStatus === 'failure') {
      const urlBudget = queryParams.get('budget')
      const couponValue = queryParams.get('couponValue')
      const startDate = queryParams.get('startDate')

      couponValue && submitCoupon(couponValue)
      startDate && setSelectedDate(moment(startDate).format())

      const isGtmNeeded = checkIsGTMPaymentEventNeeded(
        campaignNumberFromUrl,
        'failure'
      )

      // payment failed GTM
      isGtmNeeded &&
        dispatch(
          sendStripePaymentGTMThunk({
            campaignId: campaignNumberFromUrl,
            resultType: 'failure',
            userId: user.id,
            userRole: user.role as Roles,
            campaignDetails,
            user,
          })
        )
      paymentCancelledEvent({
        campaignType: campaignDetails.type,
        campaignPlatformType: CampaignPlatformTypeEnum.SPOTIFY,
        campaignNumber: amountOfCampaigns,
        campaignId: campaignDetails.id,
        userId: user.id,
        userRole: user.role as Roles,
        campaignValue: campaignDetails?.price,
        genresList: campaignDetails?.genres.map(genre => genre.name).join(),
        languagesList: campaignDetails?.languages
          .map(language => language.name)
          .join(),
        isFeedCampaign: false,
        isDanceRequired: false,
        paymentAmount: urlBudget,
        purchaseType:
          campaignDetails.type === 'first'
            ? PurchaseTypeEnum.FirstPurchase
            : PurchaseTypeEnum.Purchase,
        paymentMethod: PaymentMethodEnum.Stripe,
      })

      if (urlBudget === 'undefined') {
        setCurrentStep(2)
        return
      }

      const step = Math.ceil(currencyRate * 10)

      setBudget(
        Math.ceil(convertFromUsd((Number(urlBudget) / 10) * 10) / step) * step
      )
      setCurrentStep(3)

      history.push(`/campaigns/schedule/${campaignNumberFromUrl}`)
    }
  }, [])

  useEffect(() => {
    if (!campaignDetails) return
    if (
      userData.trigger_source === 'email-reminder' ||
      userData.trigger_source === 'SMS-reminder'
    ) {
      campaignScheduleStartEvent(
        campaignDetails.type,
        campaignDetails?.genres.map(genre => genre.name).join(),
        campaignDetails?.languages.map(language => language.name).join(),
        campaignDetails.id,
        CampaignPlatformTypeEnum.SPOTIFY,
        user.id,
        amountOfCampaigns,
        campaignDetails?.is_feed || false
      )
      setComponentDidMount(true)
    }
  }, [])

  const setContinueState = (value: boolean) => {
    setIsContinueActive({
      ...isContinueActive,
      [currentStep]: value,
    })
  }

  useEffect(() => {
    if (currentStep === 3) {
      if (paymentOption === 'creditCard') {
        if (cardOption === 'cardForm' && !isBluesnapButtonDisabled) {
          setContinueState(true)
        } else if (cardOption && cardOption !== 'cardForm') {
          setContinueState(true)
        } else {
          setContinueState(false)
        }
      } else if (paymentOption === 'paypal') {
        setContinueState(true)
      } else {
        setContinueState(false)
      }
    }
    if (currentStep === 2 && paymentOption === 'stripe') {
      setContinueState(true)
    }
  }, [currentStep, cardOption, paymentOption, isBluesnapButtonDisabled])

  // const onChangeCard = (e: RadioChangeEvent) => {
  //   setCardOption(e.target.value)
  //   changePaymentMethodEvent(user, campaignDetails.type)
  //   // setCurrentSelectedCard(e.target.value.cardLastFourDigits)
  //
  //   if (e.target.value !== 'cardForm') {
  //     // @ts-ignore
  //     const selectedSavedCard = shopper?.paymentSources?.creditCardInfo.find(
  //       // @ts-ignore
  //       card => card.creditCard.cardLastFourDigits === e.target.value
  //       // @ts-ignore
  //     ).creditCard
  //
  //     // setCurrentSelectedCard(selectedSavedCard)
  //     onChangeCardData(selectedSavedCard)
  //   } else {
  //     onChangeCardData(e.target.value)
  //     setIsAddNewCardOpened(true)
  //   }
  // }

  const closeErrorAlert = () => {
    closeBluesnapErrorAlert()
    closePaymentErrorAlert()
  }

  const onChangePaymentOption = (e: RadioChangeEvent) => {
    const currentPaymentMethod = e.target.value
    setPaymentOption(currentPaymentMethod)

    // on change payment method GTM
    paymentMethodChanged({
      campaignId: Number(campaignDetails.id),
      campaignNumber: amountOfCampaigns,
      campaignPlatform: CampaignPlatformTypeEnum.SPOTIFY,
      campaignType: campaignDetails.type,
      genreList: campaignDetails?.genres.map(genre => genre.name).join(),
      languageList: campaignDetails?.languages
        .map(language => language.name)
        .join(),
      paymentMethod:
        currentPaymentMethod === 'stripe'
          ? PaymentMethodEnum.Stripe
          : PaymentMethodEnum.PayPal,
      prevPaymentMethod:
        currentPaymentMethod === 'stripe'
          ? PaymentMethodEnum.PayPal
          : PaymentMethodEnum.Stripe,
      resultPrice: campaignDetails?.price,
      userId: user.id,
      is_feed: campaignDetails?.is_feed || false,
    })
    closeErrorAlert()
  }

  const modalPromocode = () => {
    setModalPromocode(prevState => !prevState)
    removeCoupon()
    setIsCoupon(false)
    setCouponErrorMessage(null)
  }

  const handleSubmitCoupon = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const coupon = couponForm?.coupon
    coupon && submitCoupon(coupon)
  }

  const handleResetCouponExist = () => {
    setCouponErrorMessage(null)
  }

  const onStartCheckoutEventSend = () => {
    dispatch(
      sendPaymentStartEvent(
        campaignDetails.id,
        { price: campaignDetails.price, start_date: selectedDate },
        url
      )
    )

    // start checkout GTM
    checkoutViewEvent({
      campaignType: campaignDetails.type,
      genreList: campaignDetails?.genres.map(genre => genre.name).join(),
      languageList: campaignDetails?.languages
        .map(language => language.name)
        .join(),
      campaignID: campaignDetails.id,
      price: campaignDetails?.price,
      campaignPlatform: CampaignPlatformTypeEnum.SPOTIFY,
      userId: user.id,
      campaignNumber: amountOfCampaigns,
      paymentMethod: PaymentMethodEnum.Stripe,
      is_feed: campaignDetails.is_feed || false,
    })

    locationEvent()
    pageViewEvent(user, pageInfo.Checkout)
  }

  const isCurrentStepContinueDisabled = useMemo(
    // @ts-ignore
    () => !isContinueActive[currentStep],
    [currentStep, isContinueActive]
  )

  const memoVAT = useMemo(() => {
    if (country === 'IL' || country === 'ISR') {
      return +(budget * 0.17)
    }

    return 0
  }, [budget, country])

  const memoDiscount = useMemo(
    () => (isCoupon ? (budget + memoVAT) * (discount / 100) : 0),
    [isCoupon, budget, discount, memoVAT]
  )

  const memoBalance = useMemo(
    () =>
      // @ts-ignore
      balance * currencyRate < budget + memoVAT - memoDiscount
        ? // @ts-ignore
          +(balance * currencyRate)
        : +(budget - currencyRate + memoVAT - memoDiscount),
    [budget, currencyRate, memoVAT, memoDiscount]
  )

  const memoTotal = useMemo(() => {
    const total_price_without_balance = budget + memoVAT - memoDiscount
    const result_price =
      // @ts-ignore
      total_price_without_balance > balance * currencyRate &&
      // @ts-ignore
      total_price_without_balance - balance * currencyRate >= currencyRate
        ? total_price_without_balance - memoBalance
        : currencyRate
    return +result_price.toFixed(2)
  }, [memoVAT, memoBalance, budget, memoDiscount, balance])

  const handleGoToNextStep = () => setCurrentStep(currentStep + 1)
  const handleGoToPrevStep = () => {
    // setPaymentOption('creditCard')
    setCurrentStep(currentStep - 1)
  }

  const checkIfBudgetZero = (value: number): number => {
    if (budget === 0) {
      return +(0).toFixed(2)
    }
    return +value.toFixed(2)
  }

  const onStepClick = (step: number) => {
    // if (step < currentStep) {
    //   setPaymentOption('creditCard')
    // }
    setCurrentStep(step)
  }

  const onClickContinue = () => {
    switch (currentStep) {
      case 3:
        paymentOption === 'creditCard' &&
          submitPayment(bluesnapSecurityCountry, bluesnapSecurityCardData)

        if (paymentOption === 'stripe') {
          setIsLoading(true)

          dispatch(
            submitStripePayment(
              {
                amount: calculateTotalPrice(),
                campaignValue: campaignDetails.price,
                campaignId: Number(campaignDetails.id),
                startDate: selectedDate,
                couponId: coupon?.id || null,
              },
              (err, res) => {
                setIsLoading(false)

                if (!err) {
                  window.open(res.link, '_self')
                }
              }
            )
          )
        }

        window.scrollTo(0, 0)
        onCheckoutConfirmedPaymentEventSend(
          campaignDetails,
          user.id,
          PaymentMethodEnum.Stripe
        )

        break
      case 2:
        onStartCheckoutEventSend()
        handleGoToNextStep()
        window.scrollTo(0, 0)
        break
      default:
        handleGoToNextStep()
        window.scrollTo(0, 0)
        break
    }
  }

  const handleGoBack = () => {
    switch (currentStep) {
      case 1:
        goToCampaignsList()
        break
      default:
        handleGoToPrevStep()
        break
    }
  }

  const continueText =
    currentStep === 3
      ? t('scheduleCampaignPage.confirm&Pay')
      : t('scheduleCampaignPage.continue')

  // const paymentSourcesOptions =
  //   pfToken &&
  //   shopper?.paymentSources?.creditCardInfo &&
  //   shopper?.paymentSources?.creditCardInfo?.map(({ creditCard }) => ({
  //     label: (
  //       <StyledSpan isInner>{`${creditCard.cardType} ${
  //         isMobile ? `\n` : ``
  //       }**** **** **** ${creditCard.cardLastFourDigits}`}</StyledSpan>
  //     ),
  //     value: creditCard.cardLastFourDigits,
  //   }))

  const radioOptions = [
    {
      label: (
        <RadioLabelContainer>
          <StyledSpan>{t('scheduleCampaignPage.credit')}</StyledSpan>

          <CardsImgWraper>
            <CardImg type="visa" alt="Visa Icon" src={visaLight} />

            <CardImg
              type="mastercard"
              alt="MasterCard Icon"
              src={mastercardLight}
            />

            <CardImg type="discover" alt="Discover Icon" src={discoverLight} />

            <CardImg type="JCB" alt="JCB Icon" src={jcbLight} />

            <CardImg type="diners" alt="Diners Icon" src={dinersLight} />

            <CardImg type="apple" alt="Apple Icon" src={applePay} />

            <CardImg type="google" alt="Google Icon" src={googlePay} />
          </CardsImgWraper>
        </RadioLabelContainer>
      ),
      value: 'stripe',
    },
    {
      label: (
        <StyledImgWrapper>
          <img alt="paypalLogo" src={paypalLogo} />
        </StyledImgWrapper>
      ),
      value: 'paypal',
    },
  ]

  const onCancelPaypal = () => {
    paymentCancelledEvent({
      campaignType: campaignDetails.type,
      campaignPlatformType: CampaignPlatformTypeEnum.SPOTIFY,
      campaignNumber: amountOfCampaigns,
      campaignId: campaignDetails.id,
      userId: user.id,
      userRole: user.role,
      campaignValue: campaignDetails?.price,
      genresList: campaignDetails?.genres.map(genre => genre.name).join(),
      languagesList: campaignDetails?.languages
        .map(language => language.name)
        .join(),
      isFeedCampaign: false,
      isDanceRequired: false,
      paymentAmount: campaignDetails?.price,
      purchaseType:
        campaignDetails.type === 'first'
          ? PurchaseTypeEnum.FirstPurchase
          : PurchaseTypeEnum.Purchase,
      paymentMethod: PaymentMethodEnum.PayPal,
    })
  }

  return (
    <Container>
      <PromocodePopup
        modal={isOpenModalPromocode}
        toggle={modalPromocode}
        couponErrorMessage={couponErrorMessage}
        handleResetCouponExist={handleResetCouponExist}
        handleSubmitCoupon={handleSubmitCoupon}
      />

      {isScheduleFinished && (
        <CampaignIsScheduledComponent
          startDate={dateFromString || selectedDate}
        />
      )}

      <PageTitleContainer>
        <BackButton src={arrowIcon} alt="" onClick={handleGoBack} />
        <PageTitle>{t('scheduleCampaignPage.startCampaign')}</PageTitle>
      </PageTitleContainer>
      <Steps currentStep={currentStep} setCurrentStep={onStepClick} />
      <MainContentContainer>
        <SetupContainer>
          {currentStep !== 3 && (
            <AddedTrack
              shouldDetailsAppear={currentStep !== 1}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
            />
          )}
          {currentStep === 1 && (
            <GenresAndLanguagesSettings
              setIsContinueActive={setContinueState}
              setBudget={setBudget}
            />
          )}
          {currentStep === 2 && (
            <ReachSettings
              budget={budget}
              setBudget={setBudget}
              setIsContinueActive={setContinueState}
              goToPrevStep={handleGoToPrevStep}
            />
          )}
          <HiddenContentWrapper active={currentStep === 3}>
            <ContainerPayment>
              {(bluesnapErrorText || paymentError) && (
                <BluesnapErrorContainer>
                  <BlueSnapErrorsAlert
                    // @ts-ignore
                    name={bluesnapErrorText || paymentError}
                    handleBlueSnapError={closeErrorAlert}
                  />
                </BluesnapErrorContainer>
              )}
              <StepTitle>
                {t('scheduleCampaignPage.selectPaymentMethod')}
              </StepTitle>

              <RadioAntd
                options={radioOptions}
                direction="vertical"
                defaultValue="stripe"
                onChange={onChangePaymentOption}
              />
            </ContainerPayment>
          </HiddenContentWrapper>
          {/* {currentStep === 3 && (
            <AlertProtectionWrapper>
              <IconProtection />
              <AlertProtectionWrapperText>
                <span>{t('scheduleCampaignPage.protectionTitle')}</span>
                <span>{t('scheduleCampaignPage.artistProtection')}</span>
              </AlertProtectionWrapperText>
            </AlertProtectionWrapper>
          )}

          {currentStep === 3 && (
            <SecurePaymentBlock>
              <IconLockMobile />
              <SecurePaymentText>
                <span>{t('scheduleCampaignPage.ssl')}</span>
                <span>{t('scheduleCampaignPage.protect')}</span>
              </SecurePaymentText>
            </SecurePaymentBlock>
          )} */}
        </SetupContainer>
        <Checkout
          selectedDate={selectedDate}
          isCoupon={isCoupon}
          isLoading={
            isLoading || isPaymentButtonLoading || isUpdateCampaignLoading
          }
          isContinueDisabled={isCurrentStepContinueDisabled}
          setIsScheduleFinished={setIsScheduleFinished}
          balance={checkIfBudgetZero(memoBalance)}
          total={checkIfBudgetZero(memoTotal)}
          VAT={checkIfBudgetZero(memoVAT)}
          budget={budget}
          discount={discount}
          currentStep={currentStep}
          paymentOption={paymentOption}
          onClickContinue={onClickContinue}
          onClickPromocode={modalPromocode}
          onPaypalClickSendEvents={onPaypalClickSendEvents}
        />
        <Mobile>
          {currentStep === 3 && (
            <SecurePaymentBlock>
              <IconLockMobile />
              <SecurePaymentText>
                <span>{t('scheduleCampaignPage.ssl')}</span>
                <span>{t('scheduleCampaignPage.protect')}</span>
              </SecurePaymentText>
            </SecurePaymentBlock>
          )}
          {currentStep === 3 && (
            <AlertProtectionWrapper>
              <IconProtection />
              <AlertProtectionWrapperText>
                <span>{t('scheduleCampaignPage.protectionTitle')}</span>
                <span>{t('scheduleCampaignPage.artistProtection')}</span>
              </AlertProtectionWrapperText>
            </AlertProtectionWrapper>
          )}
        </Mobile>
      </MainContentContainer>
      <ButtonsContainer>
        <TotalContainer>
          <TotalLabel>Total</TotalLabel>
          <TotalSum>{`${currencySymbol} ${checkIfBudgetZero(
            memoTotal
          )}`}</TotalSum>
        </TotalContainer>
        {paymentOption === 'paypal' && currentStep === 3 ? (
          <PaypalButtonWrapper>
            <ContinueButtonPaypal disabled={isCurrentStepContinueDisabled}>
              {continueText}
            </ContinueButtonPaypal>
            <PaypalButton
              campaignId={campaignDetails.id}
              price={campaignDetails.price}
              total={calculateTotalPrice()}
              sendPaymentInfoEvent={onClickPaypalEventSend}
              onSuccess={onSuccessPaypal}
              onClick={onPaypalClickSendEvents}
              onCancelPaypal={onCancelPaypal}
            />
          </PaypalButtonWrapper>
        ) : (
          <ContinueButton
            payment={currentStep === 3}
            disabled={
              currentStep === 2
                ? isLoading || !budget || isUpdateCampaignLoading
                : isLoading
            }
            onClick={onClickContinue}
          >
            {isLoading ? <LoadingSpinner /> : continueText}
          </ContinueButton>
        )}
      </ButtonsContainer>
    </Container>
  )
}
